import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../api';

export default function LimitsPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState({});
  const [edits, setEdits] = useState({});

  const load = useCallback(() => {
    setLoading(true);
    api.getLimits()
      .then(d => { setUsers(d.users); setEdits({}); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  function handleEdit(userId, field, value) {
    setEdits(prev => ({
      ...prev,
      [userId]: { ...prev[userId], [field]: value }
    }));
  }

  function getVal(user, field) {
    if (edits[user.id] && edits[user.id][field] !== undefined) return edits[user.id][field];
    return user[field];
  }

  async function saveLimit(user) {
    const limitUsd = parseFloat(getVal(user, 'limit_usd')) || 0;
    const periodDays = parseInt(getVal(user, 'period_days')) || 30;
    setSaving(prev => ({ ...prev, [user.id]: true }));
    try {
      await api.setLimit(user.id, limitUsd, periodDays);
      load();
    } catch {}
    setSaving(prev => ({ ...prev, [user.id]: false }));
  }

  async function resetLimit(userId) {
    setSaving(prev => ({ ...prev, [userId]: true }));
    try {
      await api.resetLimit(userId);
      load();
    } catch {}
    setSaving(prev => ({ ...prev, [userId]: false }));
  }

  if (loading) return <div style={{ padding: 32, textAlign: 'center', color: 'var(--text2)' }}>Загрузка...</div>;

  return (
    <div style={{ padding: '24px 32px', maxWidth: 1400, margin: '0 auto' }}>
      <h2 style={{ marginBottom: 20, fontSize: '1.3rem' }}>Лимиты сотрудников</h2>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
          <thead>
            <tr style={{ background: 'var(--bg3)', borderBottom: '2px solid var(--border)' }}>
              <th style={th}>Сотрудник</th>
              <th style={th}>Лимит ($)</th>
              <th style={th}>Период (дней)</th>
              <th style={th}>Потрачено ($)</th>
              <th style={th}>Осталось ($)</th>
              <th style={th}>Обновление через</th>
              <th style={th}>За месяц ($)</th>
              <th style={th}>За месяц (токены)</th>
              <th style={th}>Статус</th>
              <th style={th}>Действия</th>
            </tr>
          </thead>
          <tbody>
            {users.map(u => {
              const isEdited = edits[u.id] && (
                edits[u.id].limit_usd !== undefined || edits[u.id].period_days !== undefined
              );
              return (
                <tr key={u.id} style={{
                  borderBottom: '1px solid var(--border)',
                  opacity: u.active ? 1 : 0.5,
                  background: u.exceeded ? 'rgba(231,76,60,0.08)' : 'transparent',
                }}>
                  <td style={td}>
                    <div style={{ fontWeight: 600 }}>{u.display_login || u.internal_name}</div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--text2)' }}>
                      {u.role === 'admin' ? 'Администратор' : 'Менеджер'}
                    </div>
                  </td>
                  <td style={td}>
                    <input
                      type="number"
                      min="0"
                      step="0.5"
                      value={getVal(u, 'limit_usd')}
                      onChange={e => handleEdit(u.id, 'limit_usd', e.target.value)}
                      style={inputStyle}
                    />
                  </td>
                  <td style={td}>
                    <input
                      type="number"
                      min="1"
                      value={getVal(u, 'period_days')}
                      onChange={e => handleEdit(u.id, 'period_days', e.target.value)}
                      style={{ ...inputStyle, width: 70 }}
                    />
                  </td>
                  <td style={{ ...td, fontWeight: 600, color: u.exceeded ? 'var(--danger)' : 'var(--text)' }}>
                    ${u.spent_usd.toFixed(4)}
                  </td>
                  <td style={{ ...td, fontWeight: 600, color: u.remaining_usd <= 0 && u.limit_active ? 'var(--danger)' : 'var(--success, #27ae60)' }}>
                    {u.limit_active ? `$${u.remaining_usd.toFixed(4)}` : '—'}
                  </td>
                  <td style={td}>
                    {u.limit_active ? `${u.days_until_reset} дн.` : '—'}
                  </td>
                  <td style={td}>${u.month_spent_usd.toFixed(4)}</td>
                  <td style={td}>{u.month_tokens.toLocaleString()}</td>
                  <td style={td}>
                    {u.role === 'admin' ? (
                      <span style={{ color: 'var(--text2)', fontSize: '0.8rem' }}>Без лимита</span>
                    ) : u.exceeded ? (
                      <span style={{
                        background: 'var(--danger)', color: '#fff', padding: '2px 8px',
                        borderRadius: 4, fontSize: '0.75rem', fontWeight: 600
                      }}>ПРЕВЫШЕН</span>
                    ) : u.limit_active ? (
                      <span style={{
                        background: 'var(--success, #27ae60)', color: '#fff', padding: '2px 8px',
                        borderRadius: 4, fontSize: '0.75rem', fontWeight: 600
                      }}>Активен</span>
                    ) : (
                      <span style={{ color: 'var(--text2)', fontSize: '0.8rem' }}>Не задан</span>
                    )}
                  </td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button
                        onClick={() => saveLimit(u)}
                        disabled={saving[u.id] || !isEdited}
                        style={{
                          ...btnStyle,
                          background: isEdited ? 'var(--accent)' : 'var(--bg3)',
                          color: isEdited ? '#fff' : 'var(--text2)',
                        }}
                      >
                        {saving[u.id] ? '...' : 'Сохранить'}
                      </button>
                      {u.limit_active && (
                        <button
                          onClick={() => resetLimit(u.id)}
                          disabled={saving[u.id]}
                          style={{ ...btnStyle, background: 'var(--bg3)', color: 'var(--text)' }}
                        >
                          Обнулить
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const th = {
  padding: '10px 12px', textAlign: 'left', fontWeight: 600,
  fontSize: '0.8rem', color: 'var(--text2)', whiteSpace: 'nowrap',
};

const td = { padding: '10px 12px', verticalAlign: 'middle' };

const inputStyle = {
  width: 90, padding: '6px 8px', border: '1px solid var(--border)',
  borderRadius: 6, background: 'var(--bg)', color: 'var(--text)',
  fontSize: '0.85rem',
};

const btnStyle = {
  padding: '5px 12px', border: '1px solid var(--border)', borderRadius: 6,
  cursor: 'pointer', fontSize: '0.75rem', fontWeight: 600,
};
